import {mapLegacyPagination} from '@/store/utils'
import * as mutationTypes from './mutation-types'
import api from '@/store/api/customer'
// Modules
import customer from './customer'
import metrics from './metrics'
import {map} from 'lodash'

const initialState = () => ({
    customers: {
        data: [],
        metrics: [],
        properties: [],
        pagination: {}
    },
    types: [],
    employeeCounts: [],
    industryTypes: [],
    accountManagers: []
})

export default {
    namespaced: true,
    state: initialState(),
    getters: {
        accountManagers: state => state.accountManagers.data,
        customers: state => state.customers.data,
        metrics: state => state.customers.metrics,
        metricIds: (state, getters) => map(getters.metrics, 'id') ?? [],
        properties: state => state.customers.properties,
        pagination: state => state.customers.pagination
    },
    actions: {
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listCustomers: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listCustomers(params)
                const customers = {
                    ...response,
                    pagination: mapLegacyPagination(response.pagination)
                }

                commit(mutationTypes.SET_CUSTOMERS, customers)
                return customers
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{customer_ids: [], cam_id: number}} data
         * @returns {Promise<*>}
         */
        reallocateCustomers: async ({dispatch}, data) => {
            try {
                const response = await api.reallocateCustomers(data)
                return response
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listTypes: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listTypes(params)

                commit(mutationTypes.SET_TYPES, response.data)

                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listIndustryTypes: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listIndustryTypes(params)

                commit(mutationTypes.SET_INDUSTRY_TYPES, response.data)

                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listEmployeeCounts: async ({commit, dispatch}, params) => {
            try {
                const response = await api.listEmployeeCounts(params)

                commit(mutationTypes.SET_EMPLOYEE_COUNTS, response.data)

                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], {root: true})
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listAccountManagers: async ({ commit, dispatch }, params) => {
            try {
                const response = await api.listAccountManagers(params)

                commit(mutationTypes.SET_ACCOUNT_MANAGERS, response.data)

                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], { root: true })
                return Promise.reject(errorResponse[0])
            }
        },
        /**
         * @param {{}} params
         * @returns {Promise<*>}
         */
        listAccountManagersFull: async ({ commit, dispatch }, params) => {
            try {
                const response = await api.listAccountManagersFull(params)

                commit(mutationTypes.SET_ACCOUNT_MANAGERS, response.data)

                return response.data
            } catch (e) {
                const errorResponse = await dispatch('errors/addErrors', [e], { root: true })
                return Promise.reject(errorResponse[0])
            }
        },
        resetTypes: ({commit}) => commit(mutationTypes.RESET_TYPES),
        resetIndustryTypes: ({commit}) => commit(mutationTypes.RESET_INDUSTRY_TYPES),
        resetEmployeeCounts: ({commit}) => commit(mutationTypes.RESET_EMPLOYEE_COUNTS),
        resetAccountManagers: ({commit}) => commit(mutationTypes.RESET_ACCOUNT_MANAGERS),
        resetCustomers: ({commit}) => commit(mutationTypes.RESET_CUSTOMERS)
    },
    modules: {
        customer,
        metrics
    },
    mutations: {
        [mutationTypes.RESET_CUSTOMERS]: (state) => Object.assign(state, initialState()),
        [mutationTypes.RESET_ACCOUNT_MANAGERS]: (state) => state.accountManagers = initialState().accountManagers,
        [mutationTypes.SET_ACCOUNT_MANAGERS]: (state, data) => state.accountManagers = data,
        [mutationTypes.SET_CUSTOMERS]: (state, data) => state.customers = data,
        [mutationTypes.SET_TYPES]: (state, data) => state.types = data,
        [mutationTypes.SET_EMPLOYEE_COUNTS]: (state, data) => state.employeeCounts = data,
        [mutationTypes.SET_INDUSTRY_TYPES]: (state, data) => state.industryTypes = data,
        [mutationTypes.RESET_TYPES]: (state) => state.types = initialState().types,
        [mutationTypes.RESET_EMPLOYEE_COUNTS]: (state) => state.types = initialState().employeeCounts,
        [mutationTypes.RESET_INDUSTRY_TYPES]: (state) => state.types = initialState().industryTypes
    }
}
